import _api from '../_api';
import router from '../../../router';

import LogisticOperator from '../../../models/LogisticOperator';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    logisticOperators: [],
    pageCount: 1,
    totalCount: 2,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.logisticOperators,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
  },
  // -----------------------------------------------------------------
  mutations: {
    setLogisticOperators: (state, logisticOperators,) =>
      (state.logisticOperators = logisticOperators),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
  },
  // -----------------------------------------------------------------
  actions: {
    // get: () => [],
    get: ({ commit, }, { page, name, },) => {
      commit('logisticOperators/setLogisticOperators', [], { root: true, },);

      return _api.get({ page, name, },).then((response,) => {
        const logisticOperators = response.data.items.map(
          (logisticOperator,) => new LogisticOperator(logisticOperator,),
        );
        commit('logisticOperators/setLogisticOperators', logisticOperators, {
          root: true,
        },);
        commit(
          'logisticOperators/setPageCount',
          Math.ceil(response.data.total_count / 15,),
          { root: true, },
        );
        commit('logisticOperators/setTotalCount', response.data.total_count, {
          root: true,
        },);

        return logisticOperators;
      },);
    },
    create: async (_, value,) => {
      const newLogisticOperator = new LogisticOperator(value,).toPost;

      return new Promise((resolve, reject,) => {
        _api.
          post(newLogisticOperator,).
          then((inserted,) => {

            router.push({
              name: 'logistic-operator',
              params: { id: inserted.data._id, },
            },);

            resolve(inserted,);
          },).
          catch((error,) => {
            console.log('---------------',);

            reject(error.response,);
          },);
      },);
    },
  },
};
